import { Wallet, BellRinging, Info } from 'phosphor-react';

import { TestimonialsSlider } from '@/src/screen/components/prismic/TestimonialsSlider';

import styles from './styles.module.css';

type Reason = {
  icon: any;
  title: string;
  description: string;
};

const reasons: Reason[] = [
  {
    icon: Wallet,
    title: 'Chega de porcentagens',
    description:
      'Na Urbano Norte você paga apenas a mensalidade e o lucro vai todo para sua carteira!',
  },

  {
    icon: BellRinging,
    title: 'Não fique parado',
    description:
      'A Urbano Norte investe a todo momento em mídia e marketing, para que você sempre tenha corridas!',
  },

  {
    icon: Info,
    title: 'Chega de robôs',
    description:
      'Nossa equipe está disponível 24h para te atender. São pessoas reais, para soluções reais.',
  },

  {
    icon: Info,
    title: 'Atendimento presencial',
    description:
      'Na maioria das cidades que estamos presentes, temos pontos te atendimento presencial.',
  },
];

export const Main = (): JSX.Element => {
  return (
    <section className="relative">
      <div className={styles.main}>
        <div className="py-24 spacing-x max-w-6xl w-full mx-auto">
          <section className="text-floor-white z-10 drop-shadow-md">
            <span className="text-1xl md:text-3xl font-semibold drop-shadow">
              Todo dia, é dia de oportunidade com a
            </span>
            <h1 className="text-5xl md:text-8xl font-bold drop-shadow">
              Urbano Norte
            </h1>
          </section>
          <div className="flex p-6 mt-20 md:mt-28 flex-wrap justify-between bg-floor-white bg-opacity-80">
            {reasons.map(reason => (
              <div key="index" className="max-w-md p-6">
                <reason.icon size={25} color="#4ccd73" weight="fill" />

                <h4 className="mt-2 font-bold">{reason.title}</h4>
                <p className="mt-1">{reason.description}</p>
              </div>
            ))}
            {/* {Array.from({ length: 6 }, (_, index) => ({
              ...reasons[],
              id: index,
            })).map(reason => (
              <div key={reason.id} className="max-w-md p-6">
                <reason.icon size={25} color="#4ccd73" weight="fill" />

                <h4 className="mt-2 font-bold">{reason.title}</h4>
                <p className="mt-1">{reason.description}</p>
              </div>
            ))} */}
          </div>
        </div>
        <div className="bowl-content pb-4">
          <h1 className="text-center font-bold text-3xl md:text-6xl text-floor-white drop-shadow">
            O que nossos clientes acham.
          </h1>
        </div>
        <div className="pt-4">
          <TestimonialsSlider />
        </div>
      </div>
    </section>
  );
};
